import mustache from "mustache";
import { VentaAnimalesResponse } from "../../../../../modulos/pesaje/ganaderia/response/VentaAnimalesResponse";
import { formatFechaCorta } from "../../../../../utils/fechaUtils";
import { _2d, _miles } from "../../../../../utils/numberUtils";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { LoteInfoGanaderiaRender } from "../../../terceros/lote/loteInfo/LoteInfoGanaderiaRender";
import template from "./ventaDetailTemplate.html";

mustache.parse(template);

/** Detalle de solo lectura de una venta, con las mismas secciones que el
 *  formulario (ficha del potrero, datos, pesos individuales y resúmenes con
 *  estilo `summary-item`). Sin listeners. */
export class VentaDetailRender implements IConnectRender {
  constructor(private readonly _venta: VentaAnimalesResponse) {}

  render(): string {
    const v = this._venta;
    return mustache.render(template, {
      loteSalida: new LoteInfoGanaderiaRender(v.loteSalida).render(),
      fecha: v.fechaVenta ? formatFechaCorta(v.fechaVenta) : "—",
      cantidad: v.cantidadAnimales,
      pesos: v.pesosAnimales.map((peso, i) => ({
        n: i + 1,
        peso: _2d(peso),
      })),
      pesoMin: `${_2d(v.pesoMinimo)} kg`,
      pesoProm: `${_2d(v.pesoPromedio)} kg`,
      pesoMax: `${_2d(v.pesoMaximo)} kg`,
      pesoTotal: `${_miles(v.pesoTotal)} kg`,
      precioKg: `$ ${_miles(v.precioKilo)}`,
      valorTotal: `$ ${_miles(v.precioTotal)}`,
    });
  }

  connect(): void {}

  dispose(): void {}
}
